export const SET_LOCALE = '@FIL/APP/SET_LOCALE';
export const SET_LANGUAGE = '@FIL/APP/SET_LANGUAGE';
export const SET_REGION = '@FIL/APP/SET_REGION';
export const FETCH_LABEL = '@FIL/APP/FETCH_LABEL';
export const FETCH_LABEL_SUCCESS = '@FIL/APP/FETCH_LABEL_SUCCESS';
export const FETCH_LABEL_FAILURE = '@FIL/APP/FETCH_LABEL_FAILURE';
export const PAGE_TRANSITION = '@FIL/APP/PAGE_TRANSITION';
export const DEVICE_CONFIGURATIONS = '@FIL/APP/DEVICE_CONFIGURATIONS';
export const DEVICE_RESIZE_ACTION = '@FIL/APP/DEVICE_RESIZE';
export const SECURE_ROUTE_FLAG_ACTION = '@FIL/APP/SECURE_ROUTE_FLAG_ACTION';
export const FORMAT_CONFIG = {
  pattern: '#!',
  negativePattern: '-#!',
  separator: ',',
  decimal: '.',
  formatWithSymbol: true,
  symbol: '',
  precision: 2,
  currencyCode: 'DEFAULT_FORMAT',
};

export const FORMAT_CONFIG_ONE = {
  pattern: '#!',
  negativePattern: '-#!',
  separator: ',',
  decimal: '.',
  formatWithSymbol: true,
  symbol: '',
  precision: 1,
  currencyCode: 'DEFAULT_FORMAT',
};
export const FORMAT_CONFIG_ZERO = {
  pattern: '#!',
  negativePattern: '-#!',
  separator: ',',
  decimal: '.',
  formatWithSymbol: true,
  symbol: '',
  precision: 0,
  currencyCode: 'DEFAULT_FORMAT',
};
export const FORMAT_CONFIG_THREE = {
  pattern: '#!',
  negativePattern: '-#!',
  separator: ',',
  decimal: '.',
  formatWithSymbol: true,
  symbol: '',
  precision: 3,
  currencyCode: 'DEFAULT_FORMAT',
};

export const FORMAT_CONFIG_NONE = {
  separator: '',
  decimal: '.',
  precision: 2,
  pattern: '#',
};

export const DASHBOARD = 'dashboard';
export const RE_DASHBOARD = 'redashboard';
export const FUND_DASHBOARD = 'funddashboard';
export const FUND = 'F';
export const GFAS = 'GFAS';
export const ICRS = 'ICRS';
export const CNSLT = 'CNSLT';
export const schemeType = 'schemeType';
export const fundId = 'fundId';
export const baseCurrencyCode = 'baseCurrencyCode';
export const symbol = 'symbol';
export const PAGE_NAME_FUND_PERFORMANCE = 'fundPerfromance';
export const PAGE_NAME_FUND_PRICE = 'fundPrice';
export const PAGE_NAME_ATTRIBUTION = 'attribution';
export const PAGE_NAME_CLIENT_PERFORMANCE = 'clientPerformance';
export const PAGE_NAME_TRANSACTION_GFAS = 'transactionGfas';
export const PAGE_NAME_TRANSACTION_INST = 'transactionInst';
export const PAGE_NAME_HOLDING_GFAS = 'holdingGfas';
export const PAGE_NAME_HOLDING_INST = 'holdingInst';
export const SA = 'SA';
export const PAF = 'PAF';
export const FINANCIAL_STATEMENT = 'FINANCIAL STATEMENTS'
export const ANNUAL_FINANCIAL_STATEMENT = 'ANNUAL FINANCIAL STATEMENTS';

export const SEPERATOR_JSON = [{ lang: 'fr', seperator: ' ' }, { lang: 'en', seperator: ',' }];
export const DECIMAL_JSON = [{ lang: 'fr', decimal: ',' }, { lang: 'en', decimal: '.' }];
export const IDLE_TIMEOUT = 1800000;